<ion-content [fullscreen]="true">
  <ion-refresher
    id="refresher"
    slot="fixed"
    (ionRefresh)="doRefresh($event)"
    [disabled]="!this.platform.is('capacitor')"
  >
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <ion-grid>
    <ion-row>
      <ion-col>
        <app-info-varsling-popup
          *ngFor="let i = index; let message; of: infoMessages"
          [popupId]="i"
          [message]="message"
        ></app-info-varsling-popup>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-title>
    <h1>Min kundeprofil</h1>
  </ion-title>

  <!-- Hvis brukeren ikke har koblet kundenr mot konto så må vi be om det -->
  <div *ngIf="userInfo">
    <div
      class="aboutme_temp"
      *ngIf="!mobilnummerForceHide && !kundenummerkode && !userInfo.attributes?.kunde_id"
    >
      <p>Du har ikke koblet kundenummer mot konto.</p>
      <p>Skriv inn ditt mobilnummer og send inn.</p>

      <div>
        <form [formGroup]="mobilnummerGroup" novalidate class="form-input-ihk">
          <ion-input
            label="Mobilnummer"
            labelPlacement="stacked"
            fill="outline"
            placeholder="Mobilnummer"
            formControlName="mobilnummer"
            pattern="^[0-9 +-_]{8,}$"
            required
            type="tel"
            inputmode="tel"
            [class.red-border]="invalidMobileNumber"
          >
            @if (invalidMobileNumber) {
              <ion-icon slot="end" name="close-circle-outline" color="danger" aria-hidden="true"></ion-icon>
            }
          </ion-input>
          <ion-button
            class="save_button selected"
            [disabled]="!mobilnummerGroup.valid"
            (click)="sendSms()"
          >
            Send SMS
          </ion-button>
          @if (invalidMobileNumber) {
          <div class="error">
            <div class="flex justify-center items-center gap-2">
              <ion-icon name="close-circle-outline" color="danger"></ion-icon>
              <p class="font-bold">Fant ikke nummeret i våre systemer</p>
            </div>
            <p>
              Om problemet vedvarer ta kontakt med kundeservice på
              <a href="tel:776 12 000">776 12 000</a>.
            </p>
          </div>
          }
        </form>
      </div>
      <p>
        Eksisterende brukere kan også dele tilgang til sitt forbruk med deg, for
        eksempel hvis noen andre i din husholdning har registrert strømavtalen
        på seg. Be dem dele sitt kundeforhold med
        <b>{{ userInfo.email }}</b> under "Kundetilganger" i menyen, og start så
        appen din på nytt.
      </p>
      <br />
      <div class="text-center">
        <app-logout></app-logout>
      </div>
      <br />
      <div class="deleteMeContainer">
        <p>Ønsker du å slette din bruker på Min Side?</p>
        <ion-button (click)="deleteKCUser()">
          Se muligheter for å slette bruker
          <ion-icon name="arrow-forward-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
  </div>

  <div class="aboutme_temp" *ngIf="kundenummerkode">
    <div>Skriv inn koden du fikk på SMS</div>
    <div>
      <form
        [formGroup]="kundenummerkodeGroup"
        novalidate
        class="form-input-ihk"
      >
        <ion-input
          label="Kode"
          labelPlacement="stacked"
          fill="outline"
          placeholder="Kode"
          formControlName="kode"
          minLength="5"
          required
        ></ion-input>
        <ion-button
          class="code_button"
          [disabled]="!kundenummerkodeGroup.valid"
          (click)="sendKode()"
        >
          Bekreft kode</ion-button
        >
        <div class="ion-padding-top smalltext">
          Ingen kode? <br />
          Vent 30 sekunder, eller forsøk igjen <a href="">her</a>
        </div>
      </form>
    </div>
  </div>

  <!-- Kundeinfo -->
  <app-aboutme
    *ngIf="(userInfo && userInfo.attributes?.kunde_id)"
    [userInfo]="userInfo"
    [kundeId]="userInfo.attributes?.kunde_id[0]"
  ></app-aboutme>

  <div class="tab-content-bottom-margin"></div>
</ion-content>
